export default "__VITE_ASSET__b0b04f09__"